// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29ym_","productName":"Table_productName__3l_mA"};